import { useEffect, useState } from "react";
import { useCookiebotCallback } from "lib/hooks/useCookiebot";

export const CookiebotInfo = () => {
  const [consentDate, setConsentDate] = useState("-");
  const [consentId, setConsentId] = useState("-");

  useEffect(() => {
    updateInfo();
  }, []);

  function updateInfo() {
    const id = window.Cookiebot?.consentID;
    setConsentId(id === "0" ? "-" : id);
    setConsentDate(window.Cookiebot?.consentUTC?.toUTCString() || "-");
  }

  useCookiebotCallback("CookiebotOnLoad", updateInfo);
  useCookiebotCallback("CookiebotOnAccept", updateInfo);
  useCookiebotCallback("CookiebotOnDecline", updateInfo);

  return (
    <div className="mb-4 bg-[#e6e6eb] px-4 py-4 text-[14px] md:text-[16px]">
      <p className="font-bold">Consent date:</p>
      <p>{consentDate}</p>
      <p className="font-bold">Your consent ID:</p>
      <p className="break-all">{consentId}</p>
      <br />
      <p>
        When visiting the site for the first time, you will have been presented
        with the option to either allow or refuse certain categories of
        non-essential cookie. If you wish to make changes to the selection you
        have made, then you can do so by{" "}
        <span
          className="cursor-pointer text-cerise"
          onClick={() => {
            window.Cookiebot.show();
          }}
        >
          clicking here
        </span>
        .
      </p>
    </div>
  );
};
